<template>
  <div>
    <div class="dev05">
      设备故障信息导出
      <Icon type="ios-redo" size="25" class="auth01" @click="back"/>
    </div>
    <div class="dev07">
      <el-date-picker
        class="dev06"
        v-model="value"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions">
      </el-date-picker>
    </div>
    <div class="dev08">
<!--      <el-select class="dev09" v-model="value1" placeholder="选择导出类型">-->
<!--        <el-option-->
<!--          v-for="item in options"-->
<!--          :key="item.value"-->
<!--          :label="item.name"-->
<!--          :value="item.value">-->
<!--        </el-option>-->
<!--      </el-select>-->
      <input type="number" placeholder="本月运行总时间" class="dev09 dev12" v-model="byyx" @blur="BlurBy">
    </div>
    <div class="dev08">
      <input type="number" placeholder="上月运行总时间" class="dev09 dev12" v-model="syyx" @blur="BlurSy">
    </div>
    <div class="dev08">
      <input type="number" placeholder="上年本月运行总时间" class="dev09 dev12" v-model="snyx" @blur="BlurSn">
    </div>
    <div class="dev08">
      <input type="text" placeholder="自行设定本月故障率" class="dev09 dev12" v-model="bygzl">
    </div>
    <div class="dev08">
      <input type="text" placeholder="自行设定本月故障台时" class="dev09 dev12" v-model="bygzts">
    </div>
    <div class="dev08">
      <input type="text" placeholder="自行设定本月检维修完成率" class="dev09 dev12" v-model="bywxl">
    </div>
    <div class="dev11">
      <el-button type="primary" class="dev10" :loading="loading" round @click="daochu">导出数据</el-button>
    </div>
  </div>
</template>

<script>
  var me;
  var user;
  var menu;
  import httpDev from '@/api/device';
  import util from "../../util/util";
  export default {
    name: "gzExport",
    data() {
      return {
        bywxl:'',             //本月维修完成率
        bygzts:'',            //本月故障台时
        bygzl:'',             //本月故障率
        snyx:'',              //上年本月运行总时间
        byyx:'',              //本月运行总时间
        syyx:'',              //上月运行总时间
        value:'',             //选择的时间
        value1:'',            //选择的类型
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        // options: [{
        //   value: '1',
        //   name: '创建时间'
        // }, {
        //   value: '2',
        //   name: '审批完成时间'
        // }],
        loading:false,//按钮是否加载
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
      menu = JSON.parse(sessionStorage.getItem('menu'));
    },
    mounted() {

    },
    methods:{
      BlurSn(){
        if (me.snyx <= 0) {
          me.snyx = 1;
        }
      },
      BlurBy(){
        if (me.byyx <= 0) {
          me.byyx = 1;
        }
      },
      BlurSy(){
        if (me.syyx <= 0) {
          me.syyx = 1;
        }
      },
      back(){
        me.$router.back();
      },
      daochu(){//导出数据
        if (me.value.length == 0) {
          me.$message.error('请选择起止时间');
          return false;
        }
        if (me.byyx == '') {
          me.$message.error('请输入本月运行总时间');
          return false;
        }
        if (me.syyx == '') {
          me.$message.error('请输入上月运行总时间');
          return false;
        }
        if (me.snyx == '') {
          me.$message.error('请输入上年本月运行总时间');
          return false;
        }
        if (me.bygzl == '') {
          me.$message.error('请输入本月故障率');
          return false;
        }
        if (me.bygzts == '') {
          me.$message.error('请输入本月故障台时');
          return false;
        }
        if (me.bywxl == '') {
          me.$message.error('请输入本月检修完成率');
          return false;
        }
        me.loading = true;
        me.$Loading.start();
        let data = {
          startTime:me.value[0],
          endTime:me.value[1],
          companyId:user.companyId,
          totalrunntime:me.byyx,
          uptotalrunntime:me.syyx,
          upyeartotalrunntime:me.snyx,
          setfailurerate:me.bygzl,
          settaiwantime:me.bygzts,
          setoverhaul:me.bywxl,
          // type:1
        }
        httpDev.exportfaultrateddata(data).then(res => {
          const blob = new Blob([res],{type:'application/octet-stream'});//处理文档流
          const fileName = '设备故障记录.csv';
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
          me.loading = false;
          me.$Loading.finish();
        })
      }
    }
  }
</script>

<style scoped>
  @import "device.css";
</style>